import 'bootstrap/dist/css/bootstrap.min.css'

import '../css/main.css'

import './icons'
import './check-updates'
import { prepareForm, prepareButtons } from './form-util'
import { warnFacebookBrowserUserIfNecessary } from './facebook-util'
import { addVersion } from './util'
import { createForm,createButtons } from './form'

warnFacebookBrowserUserIfNecessary()
createForm()
prepareForm()
createButtons()
prepareButtons()
addVersion(process.env.VERSION)
